import script from "./Error.vue?vue&type=script&setup=true&lang=js"
export * from "./Error.vue?vue&type=script&setup=true&lang=js"

import "./Error.vue?vue&type=style&index=0&id=297b165c&lang=scss"

const __exports__ = script;

export default __exports__